import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import { getGuId } from "../../../utils/SecurityService";
import Close from "../../../assets/images/icons/close.svg";
import GreenMap from "../../../assets/images/icons/green-map.svg";
import GrayStar from "../../../assets/images/icons/gray-star.svg";
import ScheduleMeetingicon from "../../../assets/images/icons/schedule-meeting.svg";
import ParkingIcon from "../../../assets/images/icons/parkingIcon.svg";
import DeskIcon from "../../../assets/images/icons/DeskIcon.svg";
import MeetingIcon from "../../../assets/images/icons/meetingIcon.svg";
import userQueIcon from '../../../assets/images/icons/user-in-join-queue.svg';
import CustomSearchableDropdown from "../../Common/CustomSearchableDropdown";
import { Images } from "../../Common/Images";
import { getLocalDateString, getSafeDisplayDate, getWeekKeyFromDate } from "./calendarMonthUtils";

const JoinQueueModal = ({ date, onClose, zoneId, context }) => {
    const { t } = useTranslation();
    const {
        clickedFullDay,
        weekData,
        bookingSpotData,
        selectedTeamId,
        selectedTeamMember,
        zoneCreditValue,
        mapAvailable,
        preBookingQuestion,
        checkedPreBookingQue,
        setCheckedPreBookingQue,
        selectedMemberData,
        selectedName,
        iconzoneType,
        isLoading,
        GetRandomSpace,
        isGuestTeamMember,
        teamMemberList,
        activeGuestFlag,
        ScheduleMeeting,
        GotoMapClick,
    } = context;

        // Helper to get weekKey for a given date
        function getWeekKey() {
            const date = clickedFullDay
            console.log("click on date clickedFullDay => ", date);
            const safeDate = getSafeDisplayDate(date);
            const dayOfWeek = safeDate?.getDay();
            console.log("Number of day in week => ", dayOfWeek);
            return getWeekKeyFromDate(date);
        }

        // Prefer the date the cell handed us; clickedFullDay stays as a fallback.
        const bookingDate = date || clickedFullDay;
        const weekKey = bookingDate ? getWeekKey(bookingDate) : null;
        const bookingDateStr = getLocalDateString(bookingDate);

        // Find booking for modal from weekData first, fallback to bookingSpotData
        const bookingForModal =
            (weekKey && weekData && weekData[weekKey] && weekData[weekKey].find(
                (booking) => booking.BookingDate === bookingDateStr
            )) ||
            bookingSpotData.find(
                (booking) => booking.BookingDate === bookingDateStr
            );

        // Display helpers
        const safeBookingDate = getSafeDisplayDate(bookingDate);
        const displayDay = safeBookingDate ? safeBookingDate.getDate() : '';
        const displayMonth = safeBookingDate ? safeBookingDate.toLocaleDateString('en-US', { month: 'long' }) : '';
        const displayYear = safeBookingDate ? safeBookingDate.getFullYear() : '';

        // Vehicle selection logic (copied from MapGridZone)
        const [vehicleOpen, setVehicleOpen] = useState(false);
        const [selectedVehicle, setSelectedVehicle] = useState(null);
        const [selectedVehiclePrimaryKey, setSelectedVehiclePrimaryKey] = useState(null);
        const [requiredFields, setRequiredFields] = useState({ vehicle: "" });
        // Example: vehiclesForSpot should come from bookingForModal or props
        const vehiclesForSpot = bookingForModal?.EmployeeVehicleType || [];

        useEffect(() => {
            if (vehiclesForSpot && vehiclesForSpot.length > 0 && !selectedVehiclePrimaryKey) {
                const firstVehicle = vehiclesForSpot[0];
                const firstPk = firstVehicle.VehiclePrimaryKey;

                setSelectedVehiclePrimaryKey(firstPk);
                setSelectedVehicle(firstVehicle);
                setRequiredFields((prev) => ({
                    ...prev,
                    vehicle: ""
                }));

                console.log("Default vehicle selected:", firstVehicle.VehicleRegistrationId);
            }
        }, [vehiclesForSpot, selectedVehiclePrimaryKey]);

        // Helper: should disable Get Random Space button if vehicle required but not selected
        const isVehicleRequired = vehiclesForSpot.length > 0;
        const isVehicleSelected = !!selectedVehicle;

        // Guest random allocation — same rule as BookingModal; gates the vehicle dropdown.
        const isGuestRandomAllocation =
            selectedTeamId === null && String(selectedTeamMember) === "0";

        const varzonecreditvalue = zoneCreditValue

        const CreditValueGrey =
            (zoneCreditValue == 1 && bookingForModal?.IndividualDayCost == 0)

        const CreditValueAdd =
            (zoneCreditValue == 1 && bookingForModal?.IndividualDayCost == 1)
        console.log("CreditValueGrey", CreditValueGrey);
        console.log("CreditValueAdd", CreditValueAdd);

        const MapButton = ({ onClick }) => (
            
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onClick();
                    }}
                    className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                    style={{ cursor: "pointer" }}
                >
                    <img src={GreenMap} alt="Map" />
                    <span>{t("gotomap")}</span>
                </a>
        );

        const ScheduleMeetingButton = ({ onClick }) => (
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onClick();
                    }}
                    className="green-outline-with-icon w-100 mw-100 min-height-56"
                    style={{ cursor: "pointer" }}
                >
                    <img src={ScheduleMeetingicon} alt="Edit" />
                    <span>{t("react_schedule_meeting")}</span>
                </a>
        );

        const showMap =
            mapAvailable === 1
        const canScheduleMeeting =
            bookingForModal?.MeetingRoomAvailable === 1;
        const safeHtml = DOMPurify
            .sanitize(preBookingQuestion)
            .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');

        const samevalue = getGuId() == selectedTeamMember
        const bookingModalMemberName = isGuestRandomAllocation
            ? t("guest")
            : selectedMemberData?.FullName
            || selectedName
            || `${localStorage.getItem("firstname")} ${localStorage.getItem("lastname")}`;

        return (
            <div>
                <div className="modal ctm-modalscroll-modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="ctm-modal-header">
                                <div className="close-modal">
                                    <a onClick={onClose}>
                                        <img src={Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    <h5 className="popup-title">{t("react_no_space_left")} </h5>
                                </div>
                                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                    <div id="selectedDate" className="selected-current-date">
                                        <span>{displayDay}</span>
                                        <span>{t(displayMonth)} {displayYear}</span>
                                    </div>
                                    {varzonecreditvalue > 0 && (
                                        <div className="credit-info">
                                            <a
                                                className="orange-outline-with-icon"
                                            >
                                                {CreditValueGrey ?
                                                    (
                                                        <>
                                                            <img src={GrayStar} alt="star" />
                                                            <span>{bookingForModal?.IndividualDayCost}</span>
                                                        </>
                                                    )
                                                    :
                                                    <>
                                                        <img src={Images.OrangeStar} alt="" />
                                                        {/* <span>{(`-${bookingForModal?.IndividualDayCost}`)}</span> */}
                                                        {Number(bookingForModal?.IndividualDayCost) > 0
                                                            ? `-${bookingForModal?.IndividualDayCost}`
                                                            : bookingForModal?.IndividualDayCost}
                                                    </>
                                                }
                                            </a>
                                        </div>
                                    )}
                                </div>
                                <div className="divider-line mt-3"></div>
                                </div>
                                                  <div className="modal-des">
                    <div className="modal-scroll-inner">
                                <div className="booking-name d-flex align-items-center gap-2">
                                    <img src={Images.Participant} />
                                    <h4>{bookingModalMemberName}</h4>
                                </div>
                                {vehiclesForSpot.length > 0
                                    //&& bookingForModal?.DeskAvailable === 1 && !isGuestRandomAllocation 
                                    && (
                                        <div className="custom-dropdown modal-dropdown mb-3">
                                            <CustomSearchableDropdown
                                                items={vehiclesForSpot}
                                                // The current selected Primary Key ID
                                                value={selectedVehiclePrimaryKey}
                                                // The key from your data to show in the list (e.g., "GJ 06 XX 1234")
                                                labelKey="VehicleRegistrationId"
                                                // The key from your data used as the unique ID for logic
                                                valueKey="VehiclePrimaryKey"
                                                searchable={false}
                                                // placeholder="Select Vehicle"
                                                disabled={!vehiclesForSpot.length}
                                                onChange={(pk) => {
                                                    // 1. Update the Primary Key state for the radio/selection logic
                                                    setSelectedVehiclePrimaryKey(pk);

                                                    // 2. Find the full vehicle object from the list to update the main state
                                                    const vehicleObj = vehiclesForSpot.find(v => v.VehiclePrimaryKey === pk);
                                                    if (vehicleObj) {
                                                        setSelectedVehicle(vehicleObj);

                                                        // Optional: Debugging logs for your development
                                                        console.log("Vehicle Selected:", vehicleObj.VehicleRegistrationId);
                                                        console.log("PK:", pk);
                                                    }

                                                    // 3. Clear any existing validation errors for the 'vehicle' field
                                                    setRequiredFields(prev => ({
                                                        ...prev,
                                                        vehicle: ""
                                                    }));
                                                }}
                                            />
                                        </div>
                                    )}
                                <div className="participants-list ctm-checklist">
                                    {!!preBookingQuestion && (
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`preBookingQuestion`}
                                                checked={checkedPreBookingQue}
                                                onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                            />

                                            <label
                                                className="form-check-label ms-2"
                                                htmlFor={`preBookingQuestion`}
                                            >
                                                <span dangerouslySetInnerHTML={{ __html: safeHtml }} />

                                            </label>
                                        </div>
                                    )}
                                </div>
                                <div className="text-center my-34">
                                    {iconzoneType === 1 ? (
                                        <img src={ParkingIcon} className="img-fluid" alt="Parking Booking" />
                                    ) : iconzoneType === 2 &&
                                        bookingForModal?.MeetingRoomAvailable === 1 &&
                                        bookingForModal?.HourlySpotAvailable === 0 &&
                                        bookingForModal?.DeskAvailable === 0 ? (
                                        <img src={MeetingIcon} className="img-fluid" alt="Meeting Room Booking" />
                                    ) : iconzoneType === 2 ? (
                                        <img src={DeskIcon} className="img-fluid" alt="Desk Booking" />
                                    ) : null}
                                </div>
</div></div>
<div className="ctm-modal-footer">
                                {
                                    (() => {
                                        // if (!bookingForModal) return null;
                                        // if (isQueue === 1) {
                                        //     // Both Desk and Meeting Room available
                                        //     if (bookingForModal.DisplayQueue === 1) {
                                        if (!showMap) {
                                            return (
                                                <>
                                                    
                                                        <button
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (!isLoading) {
                                                                    const VehicleTypeId = selectedVehicle?.Id || 0;
                                                                    const fuelId = selectedVehicle?.FuelId || 0;
                                                                    const vehicleShareableId = selectedVehicle?.ShareableId || 0;
                                                                    const vehicleAccessibleId = selectedVehicle?.AccessibleId || 0;
                                                                    const vehicleRegistrationId = selectedVehicle?.VehicleRegistrationId || 0;

                                                                    GetRandomSpace(zoneId, bookingDateStr, VehicleTypeId, fuelId, vehicleShareableId, vehicleAccessibleId, vehicleRegistrationId, isGuestTeamMember ? 1 : 0);
                                                                    onClose();
                                                                }
                                                            }}
                                                            href="#" className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                                            disabled={
                                                                isLoading ||
                                                                (!!preBookingQuestion && !checkedPreBookingQue)
                                                            }
                                                            style={{
                                                                opacity:
                                                                    isLoading ||
                                                                        (!!preBookingQuestion && !checkedPreBookingQue)
                                                                        ? 0.5
                                                                        : 1,
                                                                cursor:
                                                                    isLoading ||
                                                                        (!!preBookingQuestion && !checkedPreBookingQue)
                                                                        ? "not-allowed"
                                                                        : "pointer"
                                                            }}>
                                                            <img src={userQueIcon} alt="Map" /><span>{t("react_join_to_queue")}</span>
                                                        </button>
                                                    
                                                        {canScheduleMeeting &&
                                                            (teamMemberList.length == 0 || samevalue) &&
                                                            activeGuestFlag === 0 && (
                                                                <ScheduleMeetingButton
                                                                    onClick={() => {
                                                                        if (!isLoading) {
                                                                            ScheduleMeeting(zoneId, bookingDateStr);
                                                                            onClose();
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                    
                                                </>
                                            );
                                        }
                                        return (
                                            <>
                                                
                                                <MapButton
                                                    onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                />
                                                
                                                    <button
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (!isLoading) {
                                                                const VehicleTypeId = selectedVehicle?.Id || 0;
                                                                const fuelId = selectedVehicle?.FuelId || 0;
                                                                const vehicleShareableId = selectedVehicle?.ShareableId || 0;
                                                                const vehicleAccessibleId = selectedVehicle?.AccessibleId || 0;
                                                                const vehicleRegistrationId = selectedVehicle?.VehicleRegistrationId || 0;

                                                                GetRandomSpace(zoneId, bookingDateStr, VehicleTypeId, fuelId, vehicleShareableId, vehicleAccessibleId, vehicleRegistrationId, isGuestTeamMember ? 1 : 0);
                                                                onClose();
                                                            }
                                                        }}
                                                        href="#" className="green-outline-with-icon w-100 mw-100 min-height-56"
                                                        disabled={
                                                            isLoading ||
                                                            (!!preBookingQuestion && !checkedPreBookingQue)
                                                        }
                                                        style={{
                                                            opacity:
                                                                isLoading ||
                                                                    (!!preBookingQuestion && !checkedPreBookingQue)
                                                                    ? 0.5
                                                                    : 1,
                                                            cursor:
                                                                isLoading ||
                                                                    (!!preBookingQuestion && !checkedPreBookingQue)
                                                                    ? "not-allowed"
                                                                    : "pointer"
                                                        }}>
                                                        <img src={userQueIcon} alt="Map" /><span>{t("react_join_to_queue")}</span>
                                                    </button>
                                               
                                                {canScheduleMeeting &&
                                                    (teamMemberList.length == 0 || samevalue) &&
                                                    activeGuestFlag === 0 && (
                                                        <ScheduleMeetingButton
                                                            onClick={() => {
                                                                if (!isLoading) {
                                                                    ScheduleMeeting(zoneId, bookingDateStr);
                                                                    onClose();
                                                                }
                                                            }}
                                                        />
                                                    )}
                                           
                                            </>
                                        );
                                    })()
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };


export default JoinQueueModal;
